import styled, { css } from "styled-components";
import { theme } from "../../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as ButtonStyles from "../../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";

export const Title = styled.h2<{ noBorder?: boolean }>`
    margin: 0;
    padding: ${theme.space[3] / 2}px 0;
    font-family: ${theme.fonts.bold};
    font-size: 1.3rem;
    line-height: 2rem;
    text-transform: uppercase;
    color: ${theme.colors.midnight};
    border-bottom: 1px solid ${theme.colors.platinumMedium};

    ${({ noBorder }) =>
        noBorder &&
        css`
            padding-bottom: 0;
            border-bottom: none;
        `};
`;

export const Description = styled.p`
    margin-block: ${theme.space[3] / 2}px;
    font-family: ${theme.fonts.book};
    font-size: 1.3rem;
    line-height: 2rem;
    color: ${theme.colors.midnight};
`;

export const Card = styled.div`
    padding: ${theme.space[3] / 2}px ${theme.space[2]}px;
    border: 1px solid ${theme.colors.platinumMedium};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    & + ${ButtonStyles.ButtonCta} {
        position: relative;
        top: -2px;
    }
`;

export const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: ${theme.space[3] / 2}px;
    border-bottom: 1px solid ${theme.colors.platinumMedium};
`;

export const RemoveButton = styled.button``;
